export const ContestPickType = Object.freeze({
    None: 0,
    Under: 1,
    Over: 2,
    Custom: 3
});

export const PayoutModel = Object.freeze({
    Exact: 1,
    Flex: 2,
    Pick12: 3,
    Pick16: 4,
    Assets: 5
});

export const ParlayType =  Object.freeze({
    CreateYourOwn: "CreateYourOwn",
    CreateFromPreSelected: "CreateFromPreSelected",
    UserParlay: "UserParlay"
});

export const ContestPickResult = Object.freeze({
    Pending : 0,
    Winning : 1,
    Loosing : 2,
    Won : 3,
    Lost : 4,
    Cancelled : 5
});

export const ParlayStatus = Object.freeze({
    Pending : 0,
    Active : 1,
    Completed : 2,
    Cancelled : 3
});

export const ContestStatus = Object.freeze({
    Pending : 0,
    Active : 1,
    Completed : 2,
    Cancelled : 3
});

export const PreSelectedParlayStatus = Object.freeze({
    Pending : 0,
    Active : 1,
    Expired : 2,
    Cancelled : 3
});